/**
 * Wrapper Vite del fallback intl — inyecta ENV al resolver shared.
 */

import {
  resolveIntlDualCtaFallback,
  type IntlDualCtaFallbackInput,
  type IntlDualCtaResolvedFallback,
} from "../../shared/dualCtaIntlFallback";
import {
  resolveBrandMuxFallbackPlaybackId,
  resolvePremiumHeroPlaybackIdFromEnvOnly,
} from "@/lib/muxBrandPlayback";
import { getPlansForCurrency } from "@/config/bioTemplatePremiumPlans";

export {
  INTL_DUAL_CTA_DEFAULT_MUX_PLAYBACK_ID,
  INTL_DUAL_CTA_DEFAULT_VIP_LABEL_EN,
  INTL_DUAL_CTA_DEFAULT_VIP_LABEL_ES,
  INTL_DUAL_CTA_POST_PAYMENT_PATH,
  intlDualCtaDefaultVipLabel,
  resolveVipStripeCheckoutFromFallback,
  type IntlDualCtaResolvedFallback,
  type VipStripeCheckoutOverrides,
  INTL_DUAL_CTA_DEFAULT_VARIANT_ID,
} from "../../shared/dualCtaIntlFallback";

export function resolveIntlDualCtaFallbackForVisitor(
  input: Omit<IntlDualCtaFallbackInput, "envMuxPlaybackId" | "envPriceUsd"> = {},
): IntlDualCtaResolvedFallback {
  const { vipPlan } = getPlansForCurrency("USD", "en-US");
  return resolveIntlDualCtaFallback({
    ...input,
    envMuxPlaybackId:
      resolvePremiumHeroPlaybackIdFromEnvOnly() ?? resolveBrandMuxFallbackPlaybackId(),
    envPriceUsd: vipPlan.price,
  });
}
